import React from 'react'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import classNames from 'classnames'
import { ordial } from '../../../lib/util'
import './Status.scss'

const StatusBox = styled(Box)(
  ({ theme }) => `
  opacity: ${theme.palette.score.statusOpacity};

  .content {
    &.win {
      background-color: ${theme.palette.score.win};
    }

    &.lose {
      background-color: ${theme.palette.score.lose};
    }

    &.lock {
      background-color: ${theme.palette.score.lock};
    }
  }
`
)

const Status = ({ score }) => {
  const anime = {
    initial: { x: -128 },
    animate: { x: 0 },
    exit: { x: 128 },
    transition: { duration: 0.4 }
  }

  const statusClass = {
    win: score.win > 0,
    lose: score.lose > 0,
    lock: score.lock > 0
  }

  const statusText = (() => {
    if (score.win > 0) {
      return ordial(score.win)
    } else if (score.lose > 0) {
      return 'Lose'
    } else if (score.lock > 0) {
      return `Lock ${score.lock}`
    } else {
      return ''
    }
  })()

  return (
    <StatusBox className="status">
      <AnimatePresence>
        <motion.div {...anime} key={statusText}>
          <Box className={classNames('content', statusClass)}>
            <Typography className="status-text">
              {statusText}
            </Typography>
          </Box>
        </motion.div>
      </AnimatePresence>
    </StatusBox>
  )
}

export default Status
